/**
 * our-courses 模块配置
 */
export default {
  teachingToolVideoUrl: '',
}
